(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["shipping-progress-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('shipping-progress-bar')) {
    customElements.define(
      'shipping-progress-bar',
      class ShippingProgressBar extends HTMLElement {
        connectedCallback() {
          this.threshold = parseInt(this.dataset.threshold, 10) || 0;
          this.textPre = this.dataset.textPre || '';
          this.textPost = this.dataset.textPost || '';
          this.textReached = this.dataset.textReached || '';
          this.labelEl = this.querySelector('[data-shipping-progress-label]');
          this.fillEl = this.querySelector('[data-shipping-progress-fill]');
          this.trackEl = this.querySelector('.shipping-progress-bar__track');

          this.formatter = new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: 'EUR',
          });

          this.handleCartUpdate = this.handleCartUpdate.bind(this);

          document.addEventListener('cart:update', this.handleCartUpdate);
          document.addEventListener('cart:refresh', this.handleCartUpdate);
          document.addEventListener('cart:change', this.handleCartUpdate);
        }

        disconnectedCallback() {
          document.removeEventListener('cart:update', this.handleCartUpdate);
          document.removeEventListener('cart:refresh', this.handleCartUpdate);
          document.removeEventListener('cart:change', this.handleCartUpdate);
        }

        async handleCartUpdate(event) {
          let cartTotal = this.extractTotal(event);

          if (cartTotal === null) {
            try {
              const response = await fetch('/cart.js', {
                headers: { Accept: 'application/json' },
              });
              if (!response.ok) return;
              const data = await response.json();
              cartTotal = data.total_price;
            } catch (e) {
              return;
            }
          }

          this.render(cartTotal);
        }

        extractTotal(event) {
          const detail = event && event.detail;
          if (!detail) return null;

          if (detail.resource && typeof detail.resource.total_price === 'number') {
            return detail.resource.total_price;
          }
          if (detail.cart && typeof detail.cart.total_price === 'number') {
            return detail.cart.total_price;
          }
          if (typeof detail.total_price === 'number') {
            return detail.total_price;
          }
          return null;
        }

        render(cartTotalCents) {
          if (!this.threshold || !this.fillEl || !this.labelEl) return;

          const percent = Math.min(100, (cartTotalCents / this.threshold) * 100);
          this.fillEl.style.width = percent + '%';

          const reached = cartTotalCents >= this.threshold;
          const wasReached = this.classList.contains('is-reached');

          this.classList.toggle('is-reached', reached);

          if (reached) {
            this.labelEl.textContent = this.textReached;
          } else {
            const remaining = this.threshold - cartTotalCents;
            const formatted = this.formatter.format(remaining / 100);
            this.labelEl.innerHTML = '';
            this.labelEl.appendChild(document.createTextNode(this.textPre));
            const strong = document.createElement('strong');
            strong.className = 'shipping-progress-bar__amount';
            strong.setAttribute('data-shipping-progress-amount', '');
            strong.textContent = formatted;
            this.labelEl.appendChild(strong);
            this.labelEl.appendChild(document.createTextNode(this.textPost));
          }

          if (reached && !wasReached) {
            this.fillEl.classList.remove('just-reached');
            void this.fillEl.offsetWidth;
            this.fillEl.classList.add('just-reached');
            setTimeout(() => this.fillEl.classList.remove('just-reached'), 900);
          }

          if (this.trackEl) {
            this.trackEl.setAttribute('aria-valuenow', Math.round(percent));
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
